import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FiPlus, FiKey, FiZap, FiClock } from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'
import JoinGroupModal from './JoinGroupModal'

function QuickActions({ onJoinSuccess, groups, horizontal = false }) {
  const [showJoinModal, setShowJoinModal] = useState(false)

  const actions = [
    {
      title: 'Create Group',
      description: 'Start a new group',
      icon: FiPlus,
      link: '/create-group'
    },
    {
      title: 'Join Group',
      description: 'Enter invite code',
      icon: FiKey,
      onClick: () => setShowJoinModal(true)
    },
    {
      title: 'New Round',
      description: 'Plan a round',
      icon: FiZap,
      link: '/create-round'
    },
    {
      title: 'Set Availability',
      description: 'Update schedule',
      icon: FiClock,
      link: '/my-availability'
    }
  ]

  // Horizontal layout for Dashboard
  if (horizontal) {
    return (
      <>
        {actions.map((action) => {
          const ActionWrapper = action.link ? Link : 'button'
          const wrapperProps = action.link ? { to: action.link } : { onClick: action.onClick }

          return (
            <ActionWrapper
              key={action.title}
              {...wrapperProps}
              className="flex items-center gap-3 bg-card hover:bg-surface rounded-lg px-4 py-3 transition-colors border border-border-subtle"
            >
              <div className="w-9 h-9 bg-surface rounded-lg flex items-center justify-center flex-shrink-0 border border-border-subtle">
                <SafeIcon icon={action.icon} className="w-4 h-4 text-text-secondary" />
              </div>
              <div className="text-left">
                <p className="text-sm font-medium text-text-primary">
                  {action.title}
                </p>
                <p className="text-xs text-text-muted">{action.description}</p>
              </div>
            </ActionWrapper>
          )
        })}

        <JoinGroupModal
          isOpen={showJoinModal}
          onClose={() => setShowJoinModal(false)}
          onJoinSuccess={onJoinSuccess}
        />
      </>
    )
  }

  // Default grid layout
  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {actions.map((action) => {
          const ActionWrapper = action.link ? Link : 'button'
          const wrapperProps = action.link ? { to: action.link } : { onClick: action.onClick }

          return (
            <ActionWrapper
              key={action.title}
              {...wrapperProps}
              className="block w-full h-full bg-card hover:bg-surface rounded-lg border border-border-subtle p-4 transition-colors"
            >
              <div className="flex flex-col items-center justify-center text-center space-y-3 h-full min-h-[80px]">
                <div className="w-10 h-10 bg-surface rounded-lg flex items-center justify-center border border-border-subtle">
                  <SafeIcon icon={action.icon} className="w-5 h-5 text-text-secondary" />
                </div>
                <h3 className="text-sm font-medium text-text-primary">
                  {action.title}
                </h3>
              </div>
            </ActionWrapper>
          )
        })}
      </div>

      <JoinGroupModal
        isOpen={showJoinModal}
        onClose={() => setShowJoinModal(false)}
        onJoinSuccess={onJoinSuccess}
      />
    </>
  )
}

export default QuickActions